<div class="flex flex-col gap-3 p-4">
  <mat-card [@slideInOut]>
    <mat-card-title>
      <span >Primary Point of Contact</span>
    </mat-card-title>
    <mat-card-content>
      <div class="flex flex-col gap-2">

        <div class="flex flex-col md:flex-row gap-2">
          <div class="flex flex-col w-full md:w-1/2">
            <span class="f-s-16"><strong>Contact Name</strong></span>
            {{data.legalFirstName}} {{data.legalLastName}}
          </div>
          <div class="flex flex-col w-full md:w-1/2">
            <span class="f-s-16"><strong>Contact Phone</strong></span>
            {{data.phone | mask: '(000) 000-0000 000000'}}
          </div>
        </div>

        <div class="flex flex-col md:flex-row gap-2">
          <div class="flex flex-col w-full md:w-1/2">
            <span class="f-s-16"><strong>Email Address</strong></span>
            <span>{{data.email}}</span>
          </div>
          <div class="flex flex-col w-full md:w-1/2">
            <span class="f-s-16"><strong>Preferred Language</strong></span>
            <span>{{data.language}}</span>
          </div>
        </div>

      </div>
    </mat-card-content>
  </mat-card>

  <div class="flex flex-col gap-3 justify-center items-center">
    <span style="text-align: center"><strong>
      You will only receive communication if the email address shown above has a TLC account. Oregon Psilocybin Services communicates through TLC-Messages.
    </strong></span>
    <span style="text-align: center"><strong>
      If the email address shown above is the email address that was used to create the TLC account for this application, you will receive TLC-Messages on the TLC account that was created for this application.
    </strong></span>
    <span style="text-align: center"><strong>
      If the email address shown above does NOT have a TLC account, you will need to make a new TLC account for it to receive TLC-Messages.
    </strong></span>
  </div>

  <div mat-dialog-actions class="justify-center items-center">
    <div class="flex flex-col gap-3">
      <span style="text-align: center">Does {{data.legalFirstName}} {{data.legalLastName}} have a TLC account to receive communication? Do you want them as the primary point of contact?</span>
      <div class="flex flex-row gap-3 justify-center items-center">
        <button type="button" mat-raised-button color="primary" (click)="confirm()">Yes</button>
        <button type="button" mat-raised-button color="warm" (click)="cancel()">No</button>
      </div>
    </div>
  </div>
</div>

